import React from 'react';
import {
  ActionIcon,
  Button,
  Group,
  Text,
  Tooltip
} from '@mantine/core';
import { IconFilter, IconFilterFilled, IconPlus, IconRefresh } from '@tabler/icons-react';
import { estadoInicialFiltroProyecto, estadoInicialProyecto, type ITablaProyectosVistaProps } from '../interfaces';
import Tabla from '../../../globales/componentes/tabla/tabla';
import FiltroProyectosVista from './filtroProyectosVista';

const TablaProyectosVista: React.FunctionComponent<ITablaProyectosVistaProps> = ({
  tabla,
  abrirModalProyecto,
  consultarProyectos,
  filtro,
  manejarCambioFiltroProyecto,
  habilitarFiltros,
  manejarHabilitarFiltros,
  limpiarFiltros,
  listaProyectos,
  listaPaises
}) => {

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, overflowX: 'hidden' }}>
      <Group justify="space-between" mb="md">
        <Text fw={700} size="lg">Proyectos</Text>
        <Group>
          <Group gap={4}>
            <Tooltip
              label="Refrescar"
              withinPortal
              openDelay={100}
              zIndex={9999}
              style={{ fontSize: '10px', padding: '3px 5px' }}
            >
              <ActionIcon
                variant="subtle"
                color="primary"
                radius="xl"
                onClick={() => consultarProyectos(estadoInicialFiltroProyecto)}
              >
                <IconRefresh size={16} />
              </ActionIcon>
            </Tooltip>
            <Tooltip
              label="Filtrar"
              withinPortal
              openDelay={100}
              zIndex={9999}
              style={{ fontSize: '10px', padding: '3px 5px' }}
            >
              <ActionIcon
                variant="subtle"
                color="primary"
                radius="xl"
                onClick={() => manejarHabilitarFiltros(!habilitarFiltros)}
              >
                {habilitarFiltros ? <IconFilterFilled size={16} /> : <IconFilter size={16} />}
              </ActionIcon>
            </Tooltip>
          </Group>

          <Button
            color="primary"
            variant="light"
            size='xs'
            leftSection={<IconPlus color="var(--mantine-color-primary-0)" size={12} />}
            radius="lg"
            onClick={() => abrirModalProyecto(true, estadoInicialProyecto)}
          >
            <Text fw={500} size="xs">Agregar Proyecto</Text>
          </Button>
        </Group>
      </Group>
      {habilitarFiltros && (
        <FiltroProyectosVista
          consultarProyectos={consultarProyectos}
          filtro={filtro}
          manejarCambioFiltroProyecto={manejarCambioFiltroProyecto}
          limpiarFiltros={limpiarFiltros}
          listaProyectos={listaProyectos}
          listaPaises={listaPaises}
        />
      )}
      <div style={{ flex: 1, minHeight: 0 }}>
        <Tabla tabla={tabla} />
      </div>
    </div>
  );
};

export default React.memo(TablaProyectosVista);
